import { render } from "./CareerPage.vue?vue&type=template&id=a64a2230"
import script from "./CareerPage.vue?vue&type=script&lang=js"
export * from "./CareerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__